import { api } from './client';

export interface LogEntry {
  id: string;
  source: string;
  action: string;
  task_id?: string;
  status: string;
  message: string;
  created_at: string;
}

export interface UserActivityLog {
  id: string;
  user_id: string;
  action: string;
  details?: string;
  created_at: string;
}

export const logsApi = {
  list: (filters: { source?: string; status?: string; task_id?: string; limit?: number; offset?: number } = {}) => {
    const params = new URLSearchParams();
    if (filters.source) params.set('source', filters.source);
    if (filters.status) params.set('status', filters.status);
    if (filters.task_id) params.set('task_id', filters.task_id);
    if (filters.limit) params.set('limit', String(filters.limit));
    if (filters.offset) params.set('offset', String(filters.offset));
    const qs = params.toString();
    return api.get<LogEntry[]>(`/logs${qs ? `?${qs}` : ''}`);
  },

  userActivity: (filters: { user_id?: string; action?: string; limit?: number; offset?: number } = {}) => {
    const params = new URLSearchParams();
    if (filters.user_id) params.set('user_id', filters.user_id);
    if (filters.action) params.set('action', filters.action);
    if (filters.limit) params.set('limit', String(filters.limit));
    if (filters.offset) params.set('offset', String(filters.offset));
    const qs = params.toString();
    return api.get<UserActivityLog[]>(`/logs/user-activity${qs ? `?${qs}` : ''}`);
  },
};
